import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import { createTheme } from "@mui/material";

export const theme = createTheme({
  components: {
    MuiInputBase: {
      defaultProps: {
        // This should boost the performance of the TextField components as GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount.
        // This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
        disableInjectingGlobalStyles: true,
      },
    },
  },
  typography: {
    fontFamily: "Roboto",
    h4: {
      fontSize: "20px",
      lineHeight: "20px",
      fontWeight: 500,
    },
    h5: {
      fontSize: "16px",
      lineHeight: "16px",
      fontWeight: 500,
    },

    subtitle1: {
      fontSize: "14px",
      lineHeight: "14px",
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: "14px",
      lineHeight: "14px",
      fontWeight: 500,
    },
    body1: {
      fontSize: "14px",
      lineHeight: "14px",
    },
    body2: {
      fontSize: "14px",
      lineHeight: "14px",
    },
  },

  shape: {
    borderRadius: 2,
  },
  palette: {
    mode: "light",
    primary: {
      main: "#023781",
      light: "#ffffff",
      contrastText: "#414141",
    },
    secondary: {
      main: "#deeff2",
      contrastText: "#023781",
    },
    info: {
      light: "#EDE7F6",
      main: "#EDE7F6",
      contrastText: "#000000",
    },
    success: {
      light: "#00C85333",
      main: "#00C853",
    },
    warning: {
      light: "#ffeb3b80",
      main: "#ffeb3b",
    },
  },
});
